import { Box } from "@mui/material";

export const Marker = () => {
  return <Box sx={{ m: "auto" }}>開発中です</Box>;
};
